import Calendar, { CalendarTileProperties } from "react-calendar";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { CalendarLightIcon, ChevronLeftIcon, SelectIcon } from "@App/Components/common/Icons";
import { formatDate } from "@App/utils/dates";
import { FunctionComponent } from "react";

interface DesiredDatePickerProps {
  id: string;
  label: string;
  minDate: Date;
  maxDate: Date;
  selectedDate: Date | null;
  onChange: (date: Date | null) => void;
  dateDisabled: (props: CalendarTileProperties) => boolean;
}
export const DesiredDatePicker: FunctionComponent<DesiredDatePickerProps> = ({
  id,
  label,
  minDate,
  maxDate,
  selectedDate,
  onChange,
  dateDisabled,
}: DesiredDatePickerProps) => {
  return (
    <Popover className={"relative flex flex-col cursor-pointer"}>
      <label htmlFor={`date-${id}`}>{label}</label>
      <PopoverButton className={"flex relative"}>
        <div className="mt-1 relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {<CalendarLightIcon className={"h-5 w-5"} color={"primary-900"} />}
          </div>
          <input
            className={"border border-neutral-300 rounded shadow pl-9 py-2 px-3 my-0"}
            id={`date-${id}`}
            type="text"
            placeholder={"TT.MM.JJJJ"}
            value={(selectedDate && formatDate(selectedDate, "dd.MM.yyyy")) || ""}
            onChange={() => null}
          />
          <div className="absolute right-4 top-3">
            <SelectIcon color={"neutral-500"} />
          </div>
        </div>
      </PopoverButton>
      <PopoverPanel>
        <Calendar
          minDate={minDate}
          maxDate={maxDate}
          defaultActiveStartDate={minDate}
          onChange={onChange}
          value={selectedDate}
          className={`!absolute !border-0 top-16 left-0 shadow rounded-lg font-serif p-3 z-10`}
          tileDisabled={dateDisabled}
          minDetail="month"
          locale={"de-DE"}
          prevLabel={<ChevronLeftIcon className={"w-3 h-w"} color={"primary"} />}
          nextLabel={<ChevronLeftIcon className={"w-3 h-w rotate-180"} color={"primary"} />}
        />
      </PopoverPanel>
    </Popover>
  );
};
